import {
    Box, Typography,
} from '@mui/material';
import { CopyButton } from 'src/components/common/CopyButton';

interface JsonViewerProps {
    title: string;
    data: unknown;
    maxHeight?: string;
}

export const JsonViewer = ({ title, data, maxHeight = '500px' }: JsonViewerProps): JSX.Element => (
    <Box>
        <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1,
        }}
        >
            <Typography gutterBottom variant="h6">
                {title}
            </Typography>
            <CopyButton
                size="large"
                textToCopy={JSON.stringify(data, null, 2)}
                tooltipTitle="Click to copy the JSON string to your clipboard"
            />
        </Box>
        <Box
            component="pre"
            sx={{
                backgroundColor: 'grey.100',
                padding: 2,
                borderRadius: 1,
                fontSize: '0.875rem',
                maxHeight,
                overflowX: 'auto',
                overflowY: 'auto',
                whiteSpace: 'pre',
                width: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
            }}
        >
            {JSON.stringify(data, null, 2)}
        </Box>
    </Box>
);
